/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { my, mx } from 'styled-components-spacing';

import theme from '@theme';

const { colors } = theme;

export const Separator = styled.div`
  background-color: ${colors.separator};
  ${({ vertical }) => (vertical ? 'width' : 'height')}: 1px;
  ${({ vertical }) => (vertical ? mx(4.5) : my(3.5))}
`;
